// This file is deprecated in 1.12.0 to be removed in 1.14
( function() {
"use strict";

define( [
	"jquery",
	"./data",
	"./disable-selection",
	"./focusable",
	"./form",
	"./ie",
	"./keycode",
	"./labels",
	"./jquery-patch.js",
	"./plugin",
	"./safe-active-element",
	"./safe-blur",
	"./scroll-parent",
	"./tabbable",
	"./unique-id",
	"./version"
] );
} )();



//////////////////
// WEBPACK FOOTER
// ./~/jquery-ui/ui/core.js
// module id = 556
// module chunks = 7 8 9 10